export default __webpack_public_path__ + "static/media/Icons_10.38c56b5f.svg";